const { now } = require('moment');
var Model = require('../Model');

var Document = Object.create(Model);

Document.name = 'Document';
Document['@class'] = 'Document';
Document.url = 'document';
Document.isMultipart = true;
Document.fields = {
  parent: {
    default: null,
  },
  name: {
    type: 'text',
    default: null,
    validators: {
      presence: true, 
      length: {minimum: 1, maximum: 120, default: ''},
    }
  },
  uploadedDate: {
    //type: 'date',
    hidden: true,
    default: Date.now(),
  },
  description: {
    type: 'text',
    default: null,
  },
  document: {
    name: 'document',
    type: 'file',
    validators: {
      presence: true
    }
  } 
};

module.exports = Document;